import React from 'react';

import styles from './styles.module.scss';

const Reqs = () => {
  return (
    <section className={styles.section}>
      <div className="container">
        <h2 className={styles.header} aria-label="Here’s how it works">
          Here&apos;s how it works
        </h2>
        <ol className={styles.list}>
          <li>
            <p>
              Loans are available for up to 2.5 times of your average monthly
              payroll during the year preceding the application. Note, Kabbage
              can only process loans of <strong>up to $2 million</strong>.
            </p>
          </li>
          <li>
            <p>
              If all employees are kept on payroll, SBA will forgive the portion
              of the loans used for payroll, rent, mortgage interest or
              utilities – for up to 8 weeks after the loan is issued and up to
              100% of the loan.
            </p>
          </li>
          <li>
            <p>
              Any amount that is <i>not</i> forgiven will be treated as a
              two-year loan with a 1% fixed interest rate.
            </p>
          </li>
          <li>
            <p>
              All payments (principal, interest and fees) are deferred for 6
              months; however, interest will continue to accrue over this
              period.
            </p>
          </li>
        </ol>
      </div>
    </section>
  );
};

export default Reqs;
